import {
  SET_CALL_LIST,
  SET_AGENT_DIALED_NUMBER,
  SET_CALL_CONTACTID,
  SET_CLI,
  SET_CONSULTED_CONTACT_ID,
  SET_DIALED_NUMBER_INC,
  SET_SELETED_VOICE_SESSION_ID,
  SET_SHOW_DIALED_NUMBER,
  SET_SHOW_INCOMING_SCREEN,
  SET_SHOW_VOICE_CALL,
  SET_VOICE_PLAT_FORM,
  SET_VOICE_SESSION_ID,
  SET_WEB_RTC,
  SET_END_CHAT_MODAL_DIALOG,
  SET_ISBARGINCALL,
} from "../../Redux/Actions/type";

const initialState1 = {
  isBarginCall: false,
  callList: [],
  dailedNumberInc: "",
  showIncommingscreen: false,
  agentDialedNumber: "",
  showphonedialer: false,
  contactId: "",
  consultedContactId: "",
  voiceSessionId: "",
  seletedVoiceSessionId: "",
  showVoiceCall: false,
  cli: "",
  voicePlatForm: "",
  webRTC: false,
  endchatModalDialog: false,
};

export const voiceReducer = (state = initialState1, action) => {
  switch (action.type) {
    case SET_ISBARGINCALL: {
      return {
        ...state,
        isBarginCall: action.val,
      };
    }
    case SET_CALL_LIST: {
      return {
        ...state,
        callList: action.val,
      };
    }
    case SET_DIALED_NUMBER_INC: {
      return {
        ...state,
        dailedNumberInc: action.val,
      };
    }
    case SET_SHOW_INCOMING_SCREEN: {
      return {
        ...state,
        showIncommingscreen: action.val,
      };
    }
    case SET_AGENT_DIALED_NUMBER: {
      return {
        ...state,
        agentDialedNumber: action.val,
      };
    }
    case SET_SHOW_DIALED_NUMBER: {
      return {
        ...state,
        showphonedialer: action.val,
      };
    }
    case SET_CALL_CONTACTID: {
      return {
        ...state,
        contactId: action.val,
      };
    }
    case SET_CONSULTED_CONTACT_ID: {
      return {
        ...state,
        consultedContactId: action.val,
      };
    }
    case SET_VOICE_SESSION_ID: {
      return {
        ...state,
        voiceSessionId: action.val,
      };
    }
    case SET_SELETED_VOICE_SESSION_ID: {
      return {
        ...state,
        seletedVoiceSessionId: action.val,
      };
    }
    case SET_SHOW_VOICE_CALL: {
      return {
        ...state,
        showVoiceCall: action.val,
      };
    }
    case SET_CLI: {
      return {
        ...state,
        cli: action.val,
      };
    }
    case SET_VOICE_PLAT_FORM: {
      return {
        ...state,
        voicePlatForm: action.val,
      };
    }
    case SET_WEB_RTC: {
      return {
        ...state,
        webRTC: action.val,
      };
    }
    case SET_END_CHAT_MODAL_DIALOG: {
      return {
        ...state,
        endchatModalDialog: action.val,
      };
    }
    default:
      return state;
  }
};
